@if (show()) {
  <div class="tabs-wrapper">
    <u-tab-view
      [hideMoreOptions]="true"
      [hasDelayTab]="false"
      [tabsStatic]="TABS()"
      (onChangeActiveTab)="setActiveTab($event.tab)"
      [selectedTabId]="activeTab()"
      [isPrimary]="false"
      ><u-button
        class="remove-btn"
        [label]="'Remove'"
        [versionNumber]="2"
        [typeElement]="'secondary'"
        [stateElement]="'regular'"
        [styleType]="'text'"
        [sizeElement]="'extra-small'"
        (click)="clear.emit()"
      ></u-button>
    </u-tab-view>
  </div>
}

@switch (activeTab()) {
  @case ('emoji') {
    <emoji-mart
      [set]="set"
      [showPreview]="showPreview"
      [emojiTooltip]="emojiTooltip"
      [autoFocus]="autoFocus"
      [color]="color"
      [emojiSize]="emojiSize"
      [darkMode]="darkMode"
      [backgroundImageFn]="backgroundImageFn"
      (emojiSelect)="emojiSelect.emit($event)"
    ></emoji-mart>
  }
  @case ('upload') {
    <div class="upload">
      @if (selectedFile() && imagePreview()) {
        <div class="upload-preview">
          <ng-container *ngTemplateOutlet="iconPreviewTheme; context: { theme: 'light' }"></ng-container>
          <ng-container *ngTemplateOutlet="iconPreviewTheme; context: { theme: 'dark' }"></ng-container>
        </div>
      } @else {
        <div class="upload-image">
          <u-file-upload
            [label]="'Upload Image'"
            typeElement="secondary"
            [styleType]="'outlined'"
            [accept]="acceptTypes"
            [sizeElement]="'large'"
            [fontIcon]="'upload-cloud'"
            (onSelect)="onFileSelected($event)"
            (onError)="onFileError($event)"
          ></u-file-upload>
          <span class="limitation-upload-info"
            >Only png, jpeg, svg. max file size of 5 MB <br />
            Square icons work best.</span
          >
        </div>
      }
      <div class="upload-footer">
        <u-button
          [label]="selectedFile() ? 'Back' : 'Cancel'"
          [versionNumber]="2"
          [typeElement]="'secondary'"
          [styleType]="'fill'"
          [sizeElement]="'small'"
          [stateElement]="'regular'"
          (onClick)="cancelImage()"
        ></u-button>
        <u-button
          [label]="'Save'"
          [versionNumber]="2"
          [typeElement]="'primary'"
          [stateElement]="!selectedFile() ? 'disabled' : 'regular'"
          [sizeElement]="'small'"
          (onClick)="saveImage()"
        ></u-button>
      </div>
    </div>
  }
}

<ng-template #iconPreviewTheme let-theme="theme">
  <u-theme-wrapper [theme]="theme">
    <div class="preview-image">
      <div class="image-frame">
        <u-icon
          class="image"
          [model]="{ type: 'img', value: { lightUrl: imagePreview() } }"
          [styles]="{ width: '32px', height: '32px' }"
        ></u-icon>
        <span>{{ theme === 'light' ? 'Light' : 'Dark' }} Mode</span>
      </div>
    </div>
  </u-theme-wrapper></ng-template
>
